import * as XLSX from "xlsx";
import React, { useState, useRef, useEffect, useMemo } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Overlay } from "react-bootstrap";
import { Popover } from "react-bootstrap";
import { format } from "date-fns";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import Modal from '@material-ui/core/Modal'
import "./CalendarHome.css";
import { useTable, useGlobalFilter, useSortBy } from "react-table";
import { GrFormSearch } from "react-icons/gr";
import { COLUMNS } from "../function-components/SLFComponents/SecurityCalendar/Columns";
import "../function-components/SLFComponents/SecurityCalendar/MonthYearPicker/Calender.css";
import TablePagination from '@mui/material/TablePagination';
import { Dec2022 } from "../function-components/SLFComponents/SecurityCalendar/TrainingData/Dec2022";
import { Jan2023 } from "../function-components/SLFComponents/SecurityCalendar/TrainingData/Jan2023";
import { Feb2023 } from "../function-components/SLFComponents/SecurityCalendar/TrainingData/Feb2023";

const CalendarHome = () => {
    const URl = "httpsF//atci.lkm.accenture.com/calender/${year}/${month}";
    let selectedMonth = format(new Date(), "MMM");
    let selectedYear = new Date().getFullYear();
    const [date, setDate] = useState(new Date());
    const [data, setData] = useState([]);
    const [dataNew, setDataNew] = useState([]);
    const [month, setMonth] = useState(selectedMonth);
    const [year, setYear] = useState(selectedYear);
    const [target, setTarget] = useState(null);
    const [loader, setLoader] = useState(false);
    const [downloadedFileName, setDownloadedFileName] = useState('');
    const [modelOpen, setModelOpen] = useState();
    const ref = useRef(null);
    const [inputChange, setInputChange] = useState("");
    const [show, setShow] = useState(false);
    const [searchEvent, setSearchEvent] = useState('');
    const [columnEvent, setColumnEvent] = useState();
    const [checkboxData, setCheckBoxData] = useState([]);
    const [tableFilterData, setTableFilterData] = useState([])
    const [checkboxTableFilterData, setCheckboxTableFilterData] = useState([]);
    const [searchData, setSearchData] = useState([]);
    const [pageNumber, setPageNumber] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [resetTableData, setResetTableData] = useState(false);
    // const [sortOrder, setSortOrder] = useState("ASC")

    // const defaultColumn = useMemo(
    //   () => ({
    //     width: 100,
    //     minWidth: 50,
    //     maxWidth: 100
    //   }),
    //   []
    // );
    // const [currentSort, setCurrentSort] =  useState("default")
    // const sortTypes = {
    // 	up: {
    // 		class: 'sort-up',
    // 		fn: (a, b) => a.SId - b.SId 
    // 	},
    // 	down: {
    // 		class: 'sort-down',
    // 		fn: (a, b) => b.SId  - a.SId 
    // 	},
    // 	default: {
    // 		class: 'sort',
    // 		fn: (a, b) => a
    // 	}
    // };
    // const onSortChange = () =>{
    //   let nextSort;
    //   if (currentSort === 'down'){ nextSort = 'up'}
    // 		else if (currentSort === 'up'){nextSort = 'default'}
    // 		else if (currentSort === 'default') {nextSort = 'down'}
    // setCurrentSort(nextSort);
    // }
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPageNumber(0);
    };
    const handleOpen = () => {
        setModelOpen(true);
    };
    const handleClose = () => {
        setModelOpen(false);
    };
    let nowDate = new Date();
    const handlePageChange = (event, newPage) => {
        setPageNumber(newPage);
    };
    
    // useEffect(() => {
    //     return checkboxData;
    // }, [])

    const DATA = data.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage);
    const DATA1 = tableFilterData.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage);
    const DATA2 = checkboxTableFilterData.slice(pageNumber * rowsPerPage, pageNumber * rowsPerPage + rowsPerPage);

    const handleChange = (e) => {
        const { name, checked } = e.target;
        if (name === "SelectAll") {
            let checkData = checkboxData.map((elem) => {
                return { ...elem, isChecked: checked, };
            });
            setCheckBoxData(checkData);
        } else {
            let checkData = checkboxData.map((elem) => {
                return (
                    elem.label === name ? { ...elem, isChecked: checked } : elem)
            })
            setCheckBoxData(checkData);
        }
    };
    const handleSearch = (event) => {
        setSearchEvent(event.target.value);
    };
    const handleClick = (event) => {
        setShow(!show);
        setTarget(event.target);
    };
    const selectFunction = (value) => {
        setDate(value);
        selectedMonth = format(value, "MMM");
        setMonth(selectedMonth);
        selectedYear = format(value, "yyyy");
        setYear(selectedYear);
        setShow(!show);
        fetchData(selectedMonth.toLocaleLowerCase(), selectedYear);
    };
    const fetchData = (month, year) => {
        setLoader(true)
        console.log(month,year);
        if(month=='dec' && year=='2022'){
            setLoader(false)
            setData(Dec2022);
            setDataNew(Dec2022);
            setDownloadedFileName(`Security_Training_Calendar_${month.charAt(0).toUpperCase()}${month.slice(1)}-${year}.xlsx`); 
        }
        else if(month=='jan' && year=='2023'){
            setLoader(false)
            setData(Jan2023);
            setDataNew(Jan2023);
            setDownloadedFileName(`Security_Training_Calendar_${month.charAt(0).toUpperCase()}${month.slice(1)}-${year}.xlsx`); 
        }
        else {
            setLoader(false)
            setData(Feb2023);
            setDataNew(Feb2023);
            setDownloadedFileName(`Security_Training_Calendar_${month.charAt(0).toUpperCase()}${month.slice(1)}-${year}.xlsx`); 
        }
        
        // setLoader(false)
        // setData(res.data);
        // setDataNew(res.data);
        // setDownloadedFileName(`LKM_Calendar_${month.charAt(0).toUpperCase()}${month.slice(1)}-${year}.xlsx`);
        // axios
        //   .get(`https://atci.lkm.accenture.com/LKM-Calendar-Apis/fetchCalendar/${year}/${month}`)
        //   .then((res) => {
        //     setLoader(false)
        //     setData(res.data);
        //     setDataNew(res.data);
        //     setDownloadedFileName(`LKM_Calendar_${month.charAt(0).toUpperCase()}${month.slice(1)}-${year}.xlsx`);
        //   })
        //   .catch((err) => {
        //     setLoader(false)
        //     setData([]);
        //   });
    };
    const formHandler = (e) => {
        e.preventDefault();
    };
    const globalSearch = (e) => {
        const inputVal = e.target.value;
        setInputChange(inputVal);
        if (inputVal !== "") {
            const filteredData = dataNew.filter((item) => {
                return Object.values(item)
                    .join("")
                    .toLowerCase()
                    .includes(inputVal.toLowerCase());
            });
            setData(filteredData);
        } else {
            setData(dataNew);
        }
    };

    const downloadExcel = () => {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data);
        XLSX.utils.decode_cell({});
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
        XLSX.utils.decode_cell(ws);
        XLSX.writeFile(wb, downloadedFileName);
    };

    const columns = useMemo(() => COLUMNS, []);
    const tableInstance = useTable(
        { columns, data },
        useGlobalFilter,
        useSortBy,
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        state,
    } = tableInstance;

    useEffect(() => {
        if (columnEvent === "Training Name") {
            const specificData = (Array.from(new Set(data.map((item => item["Training Name"])))));
            const uniqueData = (specificData.map((item) => { return { label: item } }));
            const checkedvalue = (uniqueData.map((elem) => {
                return { ...elem, isChecked: true };
            }))
            setCheckBoxData(uniqueData && checkedvalue)
        } else if (columnEvent === "Session Code") {
            const specificData = (Array.from(new Set(data.map((item => item["Session Code"])))))
            const uniqueData = (specificData.map((item) => { return { label: item } }))
            const checkedvalue = (uniqueData.map((elem) => {
                return { ...elem, isChecked: true };
            }))
            setCheckBoxData(uniqueData && checkedvalue)
        } else if (columnEvent === "Batch Size") {
            const specificData = (Array.from(new Set(data.map((item => item["Batch Size"])))))
            const uniqueData = (specificData.map((item) => { return { label: item } }))
            const checkedvalue = (uniqueData.map((elem) => {
                return { ...elem, isChecked: true };
            }))
            setCheckBoxData(uniqueData && checkedvalue)
        } else if (columnEvent === "Start Date") {
            const specificData = (Array.from(new Set(data.map((item => item["Start Date"])))))
            const uniqueData = (specificData.map((item) => { return { label: item } }))
            const checkedvalue = (uniqueData.map((elem) => {
                return { ...elem, isChecked: true };
            }))
            setCheckBoxData(uniqueData && checkedvalue)
        } 
        // else if (columnEvent === "TargetAudienceLevel") {
        //     const specificData = (Array.from(new Set(data.map((item => item.TargetAudienceLevel)))))
        //     const uniqueData = (specificData.map((item) => { return { label: item } }))
        //     const checkedvalue = (uniqueData.map((elem) => {
        //         return { ...elem, isChecked: true };
        //     }))
        //     setCheckBoxData(uniqueData && checkedvalue)
        // }
    }, [columnEvent])

    useEffect(() => {
        if (searchEvent !== '') {
            const uniquesearchingdata = checkboxData.filter((elem, inx) => inx === checkboxData.findIndex((elem1) => elem1.label === elem.label))
            const searchingdata = uniquesearchingdata.filter((item) => item.label.toLowerCase().includes(searchEvent))
            setSearchData(searchingdata)
        } else {
            setSearchData([])
        }
    }, [searchEvent, checkboxData])

    const noData = data.length === 0;

    useEffect(() => {
        fetchData(selectedMonth.toLocaleLowerCase(), selectedYear);
        console.log("data fetched")
    }, [])

    const displaydata = () => {
        const isCheckedData = (checkboxData.filter((item) => item.isChecked));
        if (columnEvent === "Training Name") {
            const allData = data.filter((elem) => isCheckedData.some((elem1) => elem1.label === elem["Training Name"]))
            const checkfilter = allData.filter((item) => item.isChecked !== false)
            checkfilter.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
            setCheckboxTableFilterData(checkfilter)
        }
        else if (columnEvent === "Session Code") {
            const allData = data.filter((elem) => isCheckedData.some((elem1) => elem1.label === elem["Session Code"]))
            const checkfilter = allData.filter((item) => item.isChecked !== false)
            checkfilter.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
            setCheckboxTableFilterData(checkfilter)
            setResetTableData(false)
        }
        else if (columnEvent === "Batch Size") {
            const allData = data.filter((elem) => isCheckedData.some((elem1) => elem1.label === elem["Batch Size"]))
            const checkfilter = allData.filter((item) => item.isChecked !== false)
            checkfilter.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
            setCheckboxTableFilterData(checkfilter)
            setResetTableData(false)
        }
        else if (columnEvent === "Start Date") {
            const allData = data.filter((elem) => isCheckedData.some((elem1) => elem1.label === elem["Start Date"]))
            const checkfilter = allData.filter((item) => item.isChecked !== false)
            checkfilter.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
            setCheckboxTableFilterData(checkfilter)
            setResetTableData(false)
        }
        // else if (columnEvent === "TargetAudienceLevel") {
        //     const allData = data.filter((elem) => isCheckedData.some((elem1) => elem1.label === elem.TargetAudienceLevel))
        //     const checkfilter = allData.filter((item) => item.isChecked !== false)
        //     checkfilter.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
        //     setCheckboxTableFilterData(checkfilter)
        //     setResetTableData(false)
        // }
    }

    const dataFilterBtn = () => {
        const isCheckedData = (searchData.filter((item) => item.isChecked));
        if (columnEvent === "Training Name" && searchData !== "") {
            const FilteredData = data.filter((item) => isCheckedData.some((item1) => item1.label === item["Training Name"]))
            const checkFilterData = FilteredData.filter((item) => item.isChecked !== false)
            checkFilterData.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
            setTableFilterData(checkFilterData)
            setResetTableData(false)
        } else if (columnEvent === "Session Code" && searchData !== "") {
            const FilteredData = data.filter((item) => isCheckedData.some((item1) => item1.label === item["Session Code"]))
            const checkFilterData = FilteredData.filter((item) => item.isChecked !== false)
            checkFilterData.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
            setTableFilterData(checkFilterData)
            setResetTableData(false)
        } else if (columnEvent === "Batch Size" && searchData !== "") {
            const FilteredData = data.filter((item) => isCheckedData.some((item1) => item1.label === item["Batch Size"]))
            const checkFilterData = FilteredData.filter((item) => item.isChecked !== false)
            checkFilterData.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
            setTableFilterData(checkFilterData)
            setResetTableData(false)
        } else if (columnEvent === "Start Date" && searchData !== "") {
            const FilteredData = data.filter((item) => isCheckedData.some((item1) => item1.label === item["Start Date"]))
            const checkFilterData = FilteredData.filter((item) => item.isChecked !== false)
            checkFilterData.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
            setTableFilterData(checkFilterData)
            setResetTableData(false)
        // } else if (columnEvent === "TargetAudienceLevel" && searchData !== "") {
        //     const FilteredData = data.filter((item) => isCheckedData.some((item1) => item1.label === item["TargetAudienceLevel"]))
        //     const checkFilterData = FilteredData.filter((item) => item.isChecked !== false)
        //     checkFilterData.map((deleteItem) => (delete deleteItem.isChecked, delete deleteItem.label))
        //     setTableFilterData(checkFilterData)
        //     setResetTableData(false)
        }
    }
    const tableRestBtn = () => {
        setResetTableData(true)
        setSearchEvent('');
        setSearchData([]);
        setCheckBoxData(checkboxData.map((elem) => {
            return { ...elem, isChecked: true };
        }))
        // setPageNumber(0);
    }
    const resetBtn = () => {
        setSearchEvent('');
        setSearchData([]);
        setCheckBoxData(checkboxData.map((elem) => {
            return { ...elem, isChecked: true };
        }))
    }

    const tableData = (row, index) => {
        return (
            <tr key={index} >
                <td>{row["S. NO"]}</td>
                <td>{row["Training Name"]}</td>
                <td>{row["Session Code"]}</td>
                <td>{row["Batch Size"]}</td>
                <td>{row["Start Date"]}</td>
                <td>{row["End Date"]}</td>
                <td>{row["Practice"]}</td>
                <td><a href={row.Register}>Click Here</a></td>
                {/* <td>{row.TargetAudienceLevel}</td> */}
            </tr>
        );
    }
    return (
        <>

            <div className="main_container">
                <div className="sub-container">
                    <form onSubmit={formHandler} id="form_container">
                        <div className="download-search-wrapper">
                            <span
                                onClick={downloadExcel}
                                className="download-btn"
                                title="Download Excel"
                                disabled={noData}
                            >
                                &#x2913; Download
                            </span>
                            <div className="searchWrap">
                                <div className="search-icon">
                                    <span className="search-image">
                                        <GrFormSearch />
                                    </span>
                                    <input
                                        type="search"
                                        id="search"
                                        placeholder="Search..."
                                        onChange={globalSearch}
                                        autoComplete={false}
                                        disabled={noData ? false : false}
                                        value={inputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="month-pick">
                            <label htmlFor="date" className="date-lable">
                                Choose Month :{" "}
                            </label>
                            <span className="calender_button" onClick={handleClick}>
                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/month-calendar.png"} className='calendar-img' alt="image1" />
                                <img src={process.env.PUBLIC_URL + "/images/LearningCalendar/month-calendar-hover.png"} className='calendar-hover-img' alt="image1" />
                                {`${month}-${year}`}{" "}
                            </span>
                            <Overlay
                                show={show}
                                target={target}
                                placement="right"
                                // container={ref}
                                containerPadding={0}
                            >
                                <Popover id="popover-contained">
                                    <Popover.Body>
                                        <div className="calender">
                                            <div className="calendar-container">
                                                <Calendar
                                                    onChange={selectFunction}
                                                    value={date}
                                                    maxDetail="year"
                                                    minDate={new Date(2021, 12, 1)}
                                                    maxDate={new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 1)}
                                                    tileClassName="date_tile"
                                                />
                                            </div>
                                        </div>
                                    </Popover.Body>
                                </Popover>
                            </Overlay>
                        </div>
                        {data.length === 0 ? "" :
                            <TablePagination
                                component="div"
                                count={resetTableData === true ? data.length : tableFilterData.length > 0 ? tableFilterData.length : checkboxTableFilterData.length > 0 ? checkboxTableFilterData.length : data.length}
                                page={pageNumber}
                                onPageChange={handlePageChange}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        }
                    </form>
                </div>
                {data.length === 0 ? "" : <div className='reset-table-data' onClick={tableRestBtn}>Reset Filter</div>}
                <div className="tableResponsive">
                    <table {...getTableProps()} className="mytable" id="sortingTable">
                        <thead className="thead-dark">
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th style={{ width: column.width }}>
                                            <div className="header-wrapper">
                                                <span {...column.getHeaderProps()} >
                                                    {/* <span {...column.getHeaderProps()} onClick={onSortChange}>  */}
                                                    {/* {column.isSorted?(column.isSortedDesc ? <span>&#9662;</span>:<span>&#9652;</span>):""} */}
                                                    {column.render("Header")} </span>
                                                {/* <i className={`fas fa-${sortTypes[currentSort].class}`} /> */}
                                                {/* {column.render("HeaderName")} */}
                                                {data.length === 0 ? "" : <p className="filter-icon" onClick={() => { handleOpen(); setColumnEvent(column.render("HeaderName")) }} title="Filter">{column.Img}</p>}
                                            </div>
                                            <Modal
                                                hideBackdrop
                                                open={modelOpen}
                                                onClose={handleClose}
                                                aria-labelledby="simple-modal-title"
                                                aria-describedby="simple-modal-description"
                                                className="main-model-container"
                                            >
                                                <div className="main-model-wrapper">
                                                    <div className="model">
                                                        <input type="search" value={searchEvent} placeholder="Search Here.." className="search" onChange={handleSearch} />
                                                        <div className="model-data-container">
                                                            {searchEvent.length > 0 && searchData.length === 0 ?
                                                                <p className='no-records'>No Records Found</p> :
                                                                <>
                                                                    <input type="checkbox" name="SelectAll" className="selectall" onChange={handleChange} checked={!checkboxData.some((elem) => elem?.isChecked !== true)} />
                                                                    {/* checked={checkedData.filter((elem) => elem?.isChecked !== true).length < 1} */}
                                                                    <lable for="selectall">Select All</lable>
                                                                    {searchData.length > 0 ? ((searchData.map((searchField) => {
                                                                        return (
                                                                            <>
                                                                                <div className="model-data">
                                                                                    <input type="checkbox" id="searchcheck" name={searchField.label} onChange={handleChange} checked={searchField?.isChecked || false} />
                                                                                    <lable for="searchcheck">{searchField.label}</lable>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }))) :
                                                                        checkboxData.map((field) => {
                                                                            return (
                                                                                <>
                                                                                    <div className="model-data">
                                                                                        <input type="checkbox" id={field.label} name={field.label} onChange={handleChange}
                                                                                            checked={field?.isChecked || false}
                                                                                        />
                                                                                        <lable for={field.label}>{field.label}</lable>
                                                                                    </div>
                                                                                </>
                                                                            );
                                                                        })
                                                                    }
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="model-buttons">
                                                        <div className="reset-btn">
                                                            <button onClick={resetBtn}>Reset</button>
                                                        </div>
                                                        <div className="right-buttons">
                                                            <button onClick={() => { dataFilterBtn(); handleClose(); displaydata() }}>OK</button>
                                                            <button onClick={handleClose}>Cancel</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Modal>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps}>
                            {loader ? <tr>
                                <td colSpan={14}><Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner></td></tr> : noData ? (
                                    <tr>
                                        <td colSpan={14}>
                                            {inputChange.length > 0
                                                ? "No data to display !"
                                                : "Calendar Yet to be Published !"}
                                        </td>
                                    </tr>
                                ) : (
                                resetTableData === true ?
                                    DATA.map((row, index) => {
                                        return tableData(row, index);
                                    }) :
                                    tableFilterData.length > 0 ? (
                                        DATA1.map((row, index) => {
                                            return tableData(row, index)
                                        })
                                    ) :
                                        checkboxTableFilterData.length > 0 ?
                                            DATA2.map((row, index) => {
                                                return tableData(row, index);
                                            })
                                            :
                                            //  [...DATA].sort(sortTypes[currentSort].fn).map((row, index)=>{
                                            //   return tableData(row, index);
                                            // })
                                            DATA.map((row, index) => {
                                                return tableData(row, index);
                                            })
                            )}
                        </tbody>
                    </table>
                </div>
                {data.length === 0 ? "" : <TablePagination
                    component="div"
                    count={resetTableData === true ? data.length : tableFilterData.length > 0 ? tableFilterData.length : checkboxTableFilterData.length > 0 ? checkboxTableFilterData.length : data.length}
                    page={pageNumber}
                    onPageChange={handlePageChange}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />}
            </div>
        </>
    );
};
export default CalendarHome;